import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo, { buildBreadcrumbLd } from "../components/Seo";
import PageHero from "../components/PageHero";
import Breadcrumbs from "../components/Breadcrumbs";
import ServiceCard from "../components/ServiceCard";
import { StaggerGroup } from "../components/Reveal";
import CtaSection from "../components/CtaSection";
import { services } from "../data/services";

const crumbs = [
  { label: "Startseite", to: "/" },
  { label: "Leistungen", to: "/leistungen" },
];

export default function Leistungen() {
  return (
    <div data-testid="page-leistungen">
      <Seo
        path="/leistungen"
        title="Leistungen | Entrümpelung, Haushaltsauflösung & Entsorgung Ulm/Neu-Ulm | Rümpeltaxi"
        description="Alle Leistungen von Rümpeltaxi aus Altenstadt für Ulm, Neu-Ulm und Region: Entrümpelung, Haushalts-, Wohnungs- und Nachlassauflösung, Gewerberäumung, Entsorgung, Umzug und Einlagerung."
        jsonLd={buildBreadcrumbLd(crumbs)}
      />
      <Breadcrumbs items={crumbs} />
      <PageHero
        kicker="Leistungen"
        title="Alles für eine strukturierte Räumung – aus einer Hand"
        lead="Von der einzelnen Kellerentrümpelung bis zur kompletten Haushalts- oder Gewerbeauflösung: Wählen Sie eine Leistung und erfahren Sie, wie wir vorgehen."
      />
      <section className="bg-white py-16 md:py-24">
        <div className="container-page">
          <StaggerGroup className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {services.map((s) => (
              <ServiceCard key={s.slug} service={s} />
            ))}
          </StaggerGroup>
          <div className="mt-12 rounded-sm border border-light-gray bg-light-gray p-8 md:p-10">
            <h2 className="font-heading text-2xl font-bold text-anthracite">
              Nicht sicher, welche Leistung Sie benötigen?
            </h2>
            <p className="mt-3 max-w-2xl text-base text-mid-gray">
              Beschreiben Sie uns Ihr Anliegen – wir empfehlen Ihnen das passende Vorgehen und
              erstellen ein transparentes Angebot.
            </p>
            <Link
              to="/kontakt"
              className="mt-6 inline-flex items-center gap-2 rounded-sm bg-yellow px-6 py-3.5 font-heading font-bold text-brand-black transition-colors hover:bg-yellow-dark"
              data-testid="leistungen-cta"
            >
              Unverbindlich anfragen <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
      <CtaSection />
    </div>
  );
}
